import React from 'react';
import styles from './HeaderText.module.css';

interface HeaderTextProps {
  text?: string;
}

const defaultProps = {
  text: 'Flatsharing',
};

const HeaderText: React.FC<HeaderTextProps> = ({ text = defaultProps.text }) => {
  return (
    <div className={styles.text}>
      {text}
    </div>
  );
};

export default HeaderText; 